'use client'

import { ToastProvider } from '@/components/shared/Toast'

export default function PageWrapper({ children, footer }) {
  return (
    <ToastProvider>
      <main className="min-h-screen">{children}</main>
      {footer}
    </ToastProvider>
  )
}
